export default __webpack_public_path__ + "static/media/ally_xl1.cebed33e.png";